<template>
  <div>
    <div class="card p-4 shadow-sm">
      <!-- Toast -->
      <div
        v-if="mostrarToast"
        class="toast-container position-fixed top-0 end-0 p-3"
        style="z-index: 1055"
      >
        <div class="toast show align-items-center text-white" :class="toastColor">
          <div class="d-flex">
            <div class="toast-body">
              <i :class="iconoToast" class="me-2"></i>
              {{ alerta.mensaje }}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
          </div>
        </div>
      </div>

      <!-- Encabezado -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h3 class="m-0">Empleados</h3>
        <button class="btn btn-success" @click="mostrarFormulario = true">Agregar Empleado</button>
      </div>

      <!-- Formulario -->
      <div v-if="mostrarFormulario" class="mb-4">
        <h5 class="mb-3">Nuevo Empleado</h5>
        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label">Nombres</label>
            <input v-model="nuevoEmpleado.Nombres" type="text" class="form-control" />
          </div>
          <div class="col-md-4">
            <label class="form-label">Apellidos</label>
            <input v-model="nuevoEmpleado.Apellidos" type="text" class="form-control" />
          </div>
          <div class="col-md-4">
            <label class="form-label">Teléfono</label>
            <input v-model="nuevoEmpleado.Telefono" type="text" class="form-control" />
          </div>
          <div class="col-md-4">
            <label class="form-label">Correo</label>
            <input v-model="nuevoEmpleado.Correo" type="text" class="form-control" />
          </div>
          <div class="col-md-4">
            <label class="form-label">Usuario</label>
            <input v-model="nuevoEmpleado.Usuario" type="text" class="form-control" />
          </div>
          <div class="col-md-4">
            <label class="form-label">Contraseña</label>
            <input v-model="nuevoEmpleado.Contraseña" type="password" class="form-control" />
          </div>
          <div class="col-md-4">
            <label class="form-label">Rol</label>
            <select v-model="nuevoEmpleado.IdRol" class="form-select">
              <option disabled value="">Seleccione un rol</option>
              <option v-for="rol in roles" :key="rol.IdRol" :value="rol.IdRol">
                {{ rol.Rol }}
              </option>
            </select>
          </div>
        </div>
        <div class="text-end mt-3">
          <button class="btn btn-primary me-2" @click="guardarEmpleado">Guardar</button>
          <button class="btn btn-secondary" @click="cancelarFormulario">Cancelar</button>
        </div>
      </div>

      <!-- Tabla -->
      <div class="table-responsive">
        <table class="table table-bordered text-center align-middle">
          <thead class="table-light">
            <tr>
              <th>Nombres</th>
              <th>Apellidos</th>
              <th>Teléfono</th>
              <th>Correo</th>
              <th>Usuario</th>
              <th>Rol</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="empleados.length === 0">
              <td colspan="6">No hay empleados registrados.</td>
            </tr>
            <tr v-for="emp in empleados" :key="emp.IdEmpleado">
              <td>{{ emp.Nombres }}</td>
              <td>{{ emp.Apellidos }}</td>
              <td>{{ emp.Telefono }}</td>
              <td>{{ emp.Correo }}</td>
              <td>{{ emp.Usuario }}</td>
              <td>{{ emp.rol?.Rol }}</td>
              <td>
                <button class="btn btn-primary btn-sm me-2" @click="abrirModal(emp)">Editar</button>
                <button class="btn btn-danger btn-sm" @click="abrirModalEliminar(emp)">Eliminar</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Modal Actualizar -->
      <div v-if="mostrarModal" class="modal-backdrop">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Actualizar Empleado</h5>
            <button type="button" class="btn-close" @click.stop="cerrarModal"></button>
          </div>
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label">Nombres</label>
                <input v-model="empleadoEditar.Nombres" type="text" class="form-control" />
              </div>
              <div class="col-md-6">
                <label class="form-label">Apellidos</label>
                <input v-model="empleadoEditar.Apellidos" type="text" class="form-control" />
              </div>
              <div class="col-md-6">
                <label class="form-label">Teléfono</label>
                <input v-model="empleadoEditar.Telefono" type="text" class="form-control" />
              </div>
               <div class="col-md-6">
                <label class="form-label">Correo</label>
                <input v-model="empleadoEditar.Correo" type="text" class="form-control" />
              </div>
              <div class="col-md-6">
                <label class="form-label">Usuario</label>
                <input v-model="empleadoEditar.Usuario" type="text" class="form-control" />
              </div>
              <div class="col-md-6">
                <label class="form-label">Contraseña (opcional)</label>
                <input v-model="empleadoEditar.Contraseña" type="password" class="form-control" />
              </div>
              <div class="col-md-6">
                <label class="form-label">Rol</label>
                <select v-model="empleadoEditar.IdRol" class="form-select">
                  <option disabled value="">Seleccione un rol</option>
                  <option v-for="rol in roles" :key="rol.IdRol" :value="rol.IdRol">
                    {{ rol.Rol }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer mt-3">
            <button class="btn btn-secondary" @click="cerrarModal">Cancelar</button>
            <button class="btn btn-primary" @click="actualizarEmpleado">Actualizar</button>
          </div>
        </div>
      </div>

      <!-- Modal Eliminar -->
      <div v-if="mostrarModalEliminar" class="modal-backdrop">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger">Confirmar Eliminación</h5>
            <button type="button" class="btn-close" @click="cerrarModalEliminar"></button>
          </div>
          <div class="modal-body">
            <p>¿Eliminar el empleado <strong>{{ empleadoEliminar?.Nombres }}</strong>?</p>
          </div>
          <div class="modal-footer mt-3">
            <button class="btn btn-secondary" @click="cerrarModalEliminar">Cancelar</button>
            <button class="btn btn-danger" @click="confirmarEliminar">Eliminar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";

export default {
  name: "EmpleadosGestion",
  data() {
    return {
      empleados: [],
      roles: [],
      mostrarFormulario: false,
      mostrarModal: false,
      mostrarModalEliminar: false,
      empleadoEditar: null,
      empleadoEliminar: null,
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" },
      nuevoEmpleado: {
        Nombres: "",
        Apellidos: "",
        Telefono: "",
        Correo: "",
        Usuario: "",
        Contraseña: "",
        IdRol: null
      }
    };
  },
  computed: {
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success" ? "bi bi-check-circle" : "bi bi-exclamation-circle";
    }
  },
  methods: {
    cerrarToast() {
      this.mostrarToast = false;
    },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    async obtenerEmpleados() {
      const res = await axios.get(`${API_URL}/empleados`);
      this.empleados = res.data;
    },
    async obtenerRoles() {
      const res = await axios.get(`${API_URL}/roles`);
      this.roles = res.data;
    },
    async guardarEmpleado() {
      const { Nombres, Apellidos, Telefono, Correo, Usuario, Contraseña, IdRol } = this.nuevoEmpleado;
      if (!Nombres || !Apellidos || !Telefono || !Correo || !Usuario || !Contraseña || !IdRol) {
        this.mostrarAlerta("Todos los campos son obligatorios", "danger");
        return;
      }
      try {
        await axios.post(`${API_URL}/empleados`, this.nuevoEmpleado);
        this.mostrarAlerta("Empleado agregado", "success");
        this.nuevoEmpleado = {
          Nombres: "", Apellidos: "", Telefono: "", Correo: "", Usuario: "", Contraseña: "", IdRol: ""
        };
        this.mostrarFormulario = false;
        this.obtenerEmpleados();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al guardar, el nombre de usuario podria ya existir", "danger");
      }
    },
    abrirModal(empleado) {
      this.empleadoEditar = { ...empleado, Contraseña: "" };
      this.mostrarModal = true;
    },
    cerrarModal() {
      this.empleadoEditar = null;
      this.mostrarModal = false;
    },
    async actualizarEmpleado() {
      try {
        await axios.put(`${API_URL}/empleados/${this.empleadoEditar.IdEmpleado}`, this.empleadoEditar);
        this.mostrarAlerta("Empleado actualizado", "success");
        this.cerrarModal();
        this.obtenerEmpleados();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al actualizar", "danger");
      }
    },
    abrirModalEliminar(empleado) {
      this.empleadoEliminar = { ...empleado };
      this.mostrarModalEliminar = true;
    },
    cerrarModalEliminar() {
      this.empleadoEliminar = null;
      this.mostrarModalEliminar = false;
    },
    async confirmarEliminar() {
      if (!this.empleadoEliminar) return;
      try {
        await axios.delete(`${API_URL}/empleados/${this.empleadoEliminar.IdEmpleado}`);
        this.mostrarAlerta("Empleado eliminado", "success");
        this.obtenerEmpleados();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al eliminar", "danger");
      } finally {
        this.cerrarModalEliminar();
      }
    },
    cancelarFormulario() {
      this.mostrarFormulario = false;
      this.nuevoEmpleado = {
        Nombres: "", Apellidos: "", Telefono: "", Correo: "", Usuario: "", Contraseña: "", IdRol: ""
      };
    }
  },
  mounted() {
    this.obtenerEmpleados();
    this.obtenerRoles();
  }
};
</script>


<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-content {
  background: #fff;
  width: 600px;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}
</style>
